export default __webpack_public_path__ + "static/home-video-poster-2680cdf0cefdb04495954d9275b14651.jpg";